
    var riot = require('riot')
    riot.tag2('comment-feedback-modal-form', '<div class="messaging-modal-body"> <h2 class="messaging-modal-title">{payload.modalTitle}</h2> <article class="feedback-item media"> <div class="media-object feedback-rating"> <span class="feedback-item-rating-{payload.commentRating}"></span> </div> <div class="media-body"> <time class="feedback-item-date">{payload.commentCreated}</time> <header class="feedback-item-header"> <h3> <strong>{payload.receiverMemberAlias}</strong> <span class="feedback-item-role">({payload.commentRole})</span> </h3> </header> <p class="feedback-item-comment"> {payload.commentText} </p> <small class="feedback-item-description"> {payload.itemDescription} </small> </div> </article> <p class="validation-error-text" if="{hasValidationError}">{warningmessage}</p> <textarea class="input-text messaging-modal-message {hasValidationError ? \'input-text-validation-error\': \'\'}" name="message" placeholder="Skriv din kommentar här..." tabindex="0" onkeyup="{onEdit}"></textarea> <p class="messaging-modal-info-text"><span class="info--before"></span>Du kan endast lämna en kommentar och den kan inte ångras</p> <button class="secondary-action messaging-modal-message-action" tabindex="0" onclick="{onSend}" disabled="{sendButtonDisabled}">Spara</button> <button class="default-action messaging-modal-message-action" tabindex="0" onclick="{onCancel}">Avbryt</button> </div>', '', '', function(opts) {
        var modalMixin = require('static/script/app/ui/comment-feedback/comment-feedback-modal-mixin');
        this.mixin(modalMixin);

        this.messageMaxLength = 80;
        this.hasValidationError = false;
        this.validator = this.opts.validator;
        this.sendButtonDisabled = true;
        this.payload = {};

        this.onVisible = function() {
            this.payload = opts.payload;
            this.sendMsgLength();
        }.bind(this);

        this.focusTextarea = function() {
            var breakpoints = this.opts.breakpoints;
            if (breakpoints && breakpoints.isVisible(breakpoints.xlarge)) {
                this.message.focus();
            }
        }.bind(this);

        this.hasInvalidLength = function(msg) {
            return this.validator.hasInvalidLength(0, this.messageMaxLength, msg);
        }.bind(this);

        this.resetForm = function() {
            this.message.value = '';
            this.sendButtonDisabled = true;
            this.hasValidationError = false;
            this.update();
        }.bind(this);

        this.sendMsgLength = function() {
            var msg = this.message.value;
            this.bus.trigger('ui:comment-feedback-modal-form:on-edit', { msgLength: msg.length, msg: msg });
        }.bind(this);

        this.onEdit = function() {
            var msg = this.message.value;
            var hasError = false;
            this.warningmessage = '';

            if (this.validator.isEmpty(msg)) {
                hasError = true;
                this.warningmessage = 'Du måste skriva en kommentar'
            }
            else if (this.hasInvalidLength(msg)) {
                hasError = true;
                this.warningmessage = 'Kommentaren får maximalt innehålla ' + this.messageMaxLength + ' tecken';
            }
            else if (this.validator.hasInvalidCharacters(msg)) {
                hasError = true;
                this.warningmessage = 'Tillåtna tecken förutom bokstäver och siffror är " \' ´ ` ! ? , . ; : - ( ) / + - € $';
            }

            this.hasValidationError = hasError;
            this.sendButtonDisabled = hasError;
            this.sendMsgLength();
        }.bind(this);

        this.onSend = function() {
            this.sendButtonDisabled = true;
            this.update();
            this.bus.trigger('ui:contact-modal:on-send', {
                comment: this.message.value,
                gradeId: this.opts.payload.gradeId
            });
        }.bind(this);

        this.onCancel = function(evt) {
            this.bus.trigger('ui:comment-feedback-modal-form:on-close');
        }

        this.on('before-visible', this.onVisible);
        this.on('visible', this.focusTextarea)
        this.on('mount', function () {
            this.bus.on('ui:comment-feedback-modal:after-close', this.resetForm);
        });
});

    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/comment-feedback/comment-feedback-modal-form.riot.html